import React, { useState } from "react";
import { Button, Input, Modal, message, Spin, Typography, Space } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import {
  HEADERS_EXPORT_BEN,
  POST_ROLLBACK_JOBS_LAWYERS,
} from "../../../API/apiUrls";

const { Title, Text } = Typography;

const ApprovalRollback = ({ open, close, record, handleLoad, status }) => {
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const [loading, setLoading] = useState(false);
  const { TextArea } = Input;
  const [remarkValue, setRemarkValue] = useState("");

  const handleAccept = async () => {
    const data = {
      loanId: record?.loanId,
      lawsuitId: record?.lawsuitId,
      userId: userId,
      CONTNO: record?.CONTNO,
      memo: remarkValue,
    };

    console.log(data);
    await accecptWork(data);
  };

  const accecptWork = async (dataLawsuit) => {
    console.log("Sending data...");
    setLoading(true);
    try {
      const response = await axios.post(
        POST_ROLLBACK_JOBS_LAWYERS,
        dataLawsuit,
        {
          headers: HEADERS_EXPORT_BEN,
        },
      );

      if (response.status === 200) {
        console.log("Data sent successfully:", response.data);
        message.success("บันทึกข้อมูลสำเร็จ");
        handleLoad?.();
        close(false);
        setRemarkValue("");
      } else {
        throw new Error("ไม่สามารถบันทึกข้อมูลได้");
      }
    } catch (error) {
      console.error("Error sending data:", error);
      const errorMsg = error.response?.data?.message || error.message;
      message.error(`เกิดข้อผิดพลาด: ${errorMsg}`);
    } finally {
      setLoading(false);
    }
  };

  const handdleClose = () => {
    close(false);
  };

  return (
    <Modal
      title={
        <span>
          <ExclamationCircleOutlined
            style={{ color: "#faad14", marginRight: 8 }}
          />
          ทนายคืนงานฟ้อง
        </span>
      }
      open={open}
      onCancel={handdleClose}
      footer={null}
      width={600}
    >
      <Spin spinning={loading} size="large" tip="Loading...">
        <div style={{ padding: "10px 0" }}>
          <TextArea
            placeholder="กรุณาใส่เหตุผลในการคืนงาน..."
            value={remarkValue}
            onChange={(e) => setRemarkValue(e.target.value)}
            rows={5}
            showCount
            maxLength={500}
          />

          <div
            style={{
              marginTop: 24,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Text type="secondary" style={{ fontSize: "12px", color: "red" }}>
              * ใส่เหตุผลในการคืนงานเพื่อบันทัก
            </Text>
            <Space size={10}>
              <Button danger onClick={() => handdleClose()}>
                ปิด
              </Button>
              <Button
                variant="outlined"
                color="blue"
                onClick={() => handleAccept()}
                disabled={loading || remarkValue.trim() === ""}
              >
                บันทึก
              </Button>
            </Space>
          </div>
        </div>
      </Spin>
    </Modal>
  );
};

export default ApprovalRollback;
